import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { ManagementUserModel, ManagementUserSearchModel } from '@data-layer/models/management';
import { enumUserRole } from '../enums/user';
import { PaginatedResultModel } from '@data-layer/models/common';
import { UserBlockPossibilityModel, UserModel } from '@data-layer/models/user';
import { DEFAULT_NULL_GUID } from '@constants/constants';

@Injectable({
  providedIn: 'root',
})
export class UsersManagementRepository {
  constructor(private apiService: ApiService) {}

  public getUsers(params: ManagementUserSearchModel, isShowLoader: boolean = true): Observable<PaginatedResultModel<ManagementUserModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementUserModel>>(
      `${environment.url.userManagement}`,
      { params },
      { isShowLoader },
    );
  }

  public getUser(id: string, isShowLoader: boolean = true, isUsed: boolean = false): Observable<ManagementUserModel> {
    if (!id || (!!id && id === DEFAULT_NULL_GUID)) {
      return of(null);
    }

    return this.apiService.get<ManagementUserModel>(`${environment.url.userManagement}${id}`, null, { isShowLoader, isUsed });
  }

  public setRole(id: string, roles: enumUserRole[]): Observable<never> {
    return this.apiService.put(`${environment.url.userManagement}${id}/roles`, roles);
  }

  public delete(id: UserModel['id'], reason: string): Observable<any> {
    return this.apiService.request(
      'delete',
      `${environment.url.prefixCustoms}v2/users-management/${id}/`,
      { body: { reason } },
      { isShowLoader: false },
    );
  }

  public isBlockAvailableForAdmin(userId: string): Observable<UserBlockPossibilityModel> {
    return this.apiService.get<UserBlockPossibilityModel>(
      `${environment.url.prefixCustoms}v2/users-management/${userId}/block-possibility`,
      null,
    );
  }

  public blockUserByAdmin(userId: string, isBlockedNote: string): Observable<any> {
    return this.apiService.request('delete', `${environment.url.prefixCustoms}v2/users-management/${userId}`, { body: { isBlockedNote } });
  }

  public activateUserByAdmin(userId: string): Observable<any> {
    return this.apiService.patch(`${environment.url.prefixCustoms}v2/users-management/${userId}`);
  }
}
